import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { cleanSubscriptionName } from '../../models/Subscription';
import { PaymentData } from '../../models/PaymentData';
import { SubscriptionBundle } from '../../models/SubscriptionBundle';
import { Discount, ItemConfig, Option, Subscription } from '@co-assist/library';

const bundleList: Array<Subscription> = [
    new Subscription({
        name: 'economy3',
        alreadyOwnWatch: false,
        watchPrice: 269.99,
        servicePrice: 29.99,
        debitingOffset: 30,
        firstDebitingOffset: 30
    }),
    new Subscription({
        name: 'liberty2',
        alreadyOwnWatch: false,
        watchPrice: 0.0,
        servicePrice: 44.99,
        debitingOffset: 30,
        firstDebitingOffset: 0
    }),
    new Subscription({
        name: 'saved',
        alreadyOwnWatch: true,
        watchPrice: 0.0,
        servicePrice: 15,
        firstDebitingOffset: 180,
        debitingOffset: 30
    }),
    new Subscription({
        name: 'NONE', alreadyOwnWatch: true,
        watchPrice: 0.0,
        servicePrice: 0.0,
        firstDebitingOffset: -1,
        debitingOffset: -1
    })
];

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnChanges {
    @Input() itemConfig: ItemConfig;
    @Input() options: Option[];
    @Input() subscriptionBundle: SubscriptionBundle;
    currentSubscription: Subscription;
    @Output() currentSection: EventEmitter<{ section, direction }> = new EventEmitter<{ section, direction }>();
    @Output() paymentEmitter: EventEmitter<PaymentData> = new EventEmitter<PaymentData>();
    @Output() discountEmitter: EventEmitter<Discount> = new EventEmitter<Discount>();
    @Output() subscriptionEmitter: EventEmitter<Subscription> = new EventEmitter<Subscription>();
    @Output() taxCreditEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() additionalInfoEmitter: EventEmitter<string> = new EventEmitter<string>();
    @Output() optionEmitter: EventEmitter<Array<Option>> = new EventEmitter<Array<Option>>();

    allowNotSavePayment: boolean = true;
    economy: any = {
        name: 'economy3',
        description: [
            'ECONOMY_CREDIT_TAX',
            'FEE',
            'ECONOMY_MONTHLY',
            'ALL_FUNCTIONNALITIES',
            'ECONOMY_NO_ENGAGEMENT'
        ]
    };
    liberty: any = {
        name: 'liberty2',
        description: [
            'LIBERTY_CREDIT_TAX',
            'FEE',
            'WATCH_RENT',
            'ALL_FUNCTIONNALITIES',
            'NO_ENGAGEMENT',
        ]
    };
    saved: any = {
        name: 'saved',
        description: [
            'SIX_MONTH',
            'CONTINUITY',
            'ALL_FUNCTIONNALITIES',
            'NO_ENGAGEMENT',
            'TAX_CREDIT'
        ]
    };
    none: any = {
        name: 'NONE',
        description: [
            'SIX_MONTH',
            'ALL_FUNCTIONNALITIES',
            'NO_ENGAGEMENT',
            'TAX_CREDIT'
        ]
    };
    constructor() { }

    ngOnChanges(): void {
        if (this.itemConfig.alreadyOwn && this.options.filter(opt => opt.name !== 'FEE').length > 0 && (!this.currentSubscription || this.currentSubscription.name !== 'saved')) {
            this.allowNotSavePayment = false;
            this.next('saved', this.itemConfig.alreadyOwn);
        }
    }

    next(bundleName: string, alreadyOwnWatch: boolean) {
        this.currentSubscription = bundleList.find(item => (item.alreadyOwnWatch === alreadyOwnWatch && item.name === bundleName));
        if (alreadyOwnWatch && (['saved', 'none'].includes(bundleName))) {
            this.options = this.options.filter(opt => opt.name !== 'FEE');
        }
        this.optionEmitter.emit(this.options);
        this.subscriptionEmitter.emit(this.currentSubscription);
        if (bundleName.toLowerCase() !== 'none') {
            setTimeout(() => document.getElementById('paymentPart').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' }), 500);
        }
    }

    previous() {
        this.currentSection.emit({ section: 'payment', direction: 'back' });
    }

    updatePaymentData(paymentdata: PaymentData): void {
        this.paymentEmitter.emit(paymentdata);
        this.subscriptionBundle.paymentData = paymentdata;
    }

    updateTaxCreditChange(taxCreditValue: boolean): void {
        this.taxCreditEmitter.emit(taxCreditValue);
    }

    updateDiscount(discount: Discount): void {
        this.discountEmitter.emit(discount);
        this.subscriptionBundle.discount = discount;
    }

    updateAdditionalInfo(info: string): void {
        this.additionalInfoEmitter.emit(info);
    }
    cleanSubscriptionName(name: string): string {
        return cleanSubscriptionName(name);
    }
}
